import { COLORS } from '@/constants';
import { Button } from '@mui/material';

import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 50px;
  margin-top: 4px;
`;

export const StyledImage = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 6px;
  border-width: 1px;
  border: 1px solid ${COLORS['neutral/200']};
  flex-shrink: 0;

  object-fit: contain;
`;

export const ModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 20px 24px;
  max-width: 600px;
  max-height: 90vh;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: flex-end;
  width: min(1200px, 95vw);
`;

export const StyledButton = styled(Button)`
  &&.MuiButton-root {
    width: fit-content;
    white-space: nowrap;
    padding: 11.5px 12px;
    height: auto;
  }
`;
